<div style="display: flex; flex-direction: column;">
    <div class="challenge-card">
        <div class="header">
            <h3 class="title">{{challenge.Metrics}}</h3>
            <div class="status-container">
                <div class="status-circle" [ngClass]="{'status-color-upcoming': challengeStatus === 'upcoming' || !isPendingOngoing(), 'status-color-ended': challengeStatus === 'ended'}"></div>
                <span class="status-text">{{challengeStatus === "pending" ? getPendingLabel() : getStatusLabel()}}</span>
            </div>
        </div>
        <span *ngIf="getDate('start') === getDate('end');else endDate" class="date">{{getFormattedDate(getDate('start'))}}</span>
        <ng-template #endDate>
            <span class="date">{{getFormattedDate(getDate('start'))}} - {{getFormattedDate(getDate('end'))}}</span>
        </ng-template>
        <div class="score-container" *ngIf="challengeStatus !== 'upcoming' && challengeStatus !== 'pending'">
            <div class="score">
                <span class="subtitle" cvLocalizedText langSection="Challenges" langKey="My_Score">My Score</span>
                <span class="score-value">{{getScore().score}}</span>
            </div>
            <div class="score">
                <span class="subtitle" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</span>
                <span class="score-value">{{getScore().leading}}</span>
            </div>
        </div>
        <div class="reward-container">
            <div class="reward">
                <span class="subtitle" cvLocalizedText langSection="Challenges" langKey="Wager_Coins">Wager coins:</span>&nbsp;
                <span class="reward-value">{{challenge.Wager | cvNumberLocalize}}</span>
            </div>
            <div class="separator" *ngIf="challengeStatus !== 'upcoming' && challengeStatus !== 'pending'"></div>
            <div class="reward" *ngIf="challengeStatus !== 'upcoming' && challengeStatus !== 'pending'" >
                <span class="subtitle" cvLocalizedText langSection="Challenges" langKey="Prize">Prize:</span>&nbsp;
                <span class="reward-value">{{challenge.Pot | cvNumberLocalize}}</span>
            </div>
        </div>
        <div class="link-container">
            <span class="link-text" (click)="openParticipantsModal()">{{getFormattedParticipantCount()}}</span>
            <div class="separator" *ngIf="challengeStatus !== 'upcoming' && challengeStatus !== 'pending'"></div>
            <span class="link-text" cvLocalizedText langSection="Challenges" langKey="Leaderboard_Card" *ngIf="challengeStatus !== 'upcoming' && challengeStatus !== 'pending'" (click)="openLeaderboardModal()">Leaderboard</span>
        </div>
    </div>
    <div *ngIf="challengeStatus === 'pending'" class="d-flex justify-content-between align-items-center flex-wrap invitation-container">
        <span class="expires_text"><span cvLocalizedText langSection="Challenges" langKey="Expires_In">Expires in</span> {{expiresIn}}</span>
        <div class="d-flex">
            <button class="cxone-btn btn btn-big btn-secondary invite-button" (click)="declineChallenge()"><span cvLocalizedText langSection="Challenges" langKey="Decline">Decline</span></button>
            <button class="cxone-btn btn btn-big btn-primary invite-button" (click)="acceptChallenge()"><span cvLocalizedText langSection="Challenges" langKey="Accept">Accept</span></button>
        </div>
    </div>
</div>